import { Outlet, useNavigate } from 'react-router-dom'
import { useOktaAuth } from '@okta/okta-react'
import {
  AppBar,
  Box,
  Button,
  Container,
  Toolbar,
  Typography,
} from '@mui/material'
import { SecurityOutlined, LogoutOutlined } from '@mui/icons-material'

export default function Layout() {
  const { oktaAuth } = useOktaAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await oktaAuth.signOut()
    navigate('/login')
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar>
          <SecurityOutlined sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            HR Fraud Detection Agent
          </Typography>
          <Button color="inherit" onClick={handleLogout} startIcon={<LogoutOutlined />}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4, flex: 1 }}>
        <Outlet />
      </Container>
    </Box>
  )
}
